import { render } from "./KimbapBody.vue?vue&type=template&id=3ee1e2e6&scoped=true"
import script from "./KimbapBody.vue?vue&type=script&lang=js"
export * from "./KimbapBody.vue?vue&type=script&lang=js"

import "./KimbapBody.vue?vue&type=style&index=0&id=3ee1e2e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee1e2e6"]])

export default __exports__